<template>
  <div>
    <DialogBase
      title="Cấu hình đại lý"
      :visible.sync="isOpenConfigBrandDialog"
      width="620px"
      panel-icon="el-icon-setting"
      panel-title="CẤU HÌNH THAM SỐ GIAO DỊCH"
      panel-subtitle="Thiết lập quy tắc nhận diện mã thanh toán và cấu hình hạn mức giao dịch tối đa của đại lý."
      :confirm-loading="loading.submit"
      confirm-text="Cập nhật cấu hình"
      cancel-text="Hủy bỏ"
      @before-close="handleClose"
      @cancel="handleClose"
      @confirm="submitForm"
      @open="handleOpen"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-position="top"
        class="modern-form"
      >
        <el-form-item label="Nhận diện mã thanh toán" prop="payment_code">
          <el-radio-group v-model="formData.payment_code" class="modern-radio-group">
            <el-radio label="on">Có nhận diện</el-radio>
            <el-radio label="off">Không nhận diện</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="Tiền tố mã thanh toán (Prefix)" prop="payment_code_prefix">
          <el-input
            v-model="formData.payment_code_prefix"
            placeholder="Nhập tiền tố in hoa (ví dụ: OGV)..."
            maxlength="5"
            show-word-limit
          />
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Độ dài tối thiểu hậu tố" prop="payment_code_suffix_from">
              <el-input-number
                v-model="formData.payment_code_suffix_from"
                :min="1"
                :max="30"
                class="full-width-number"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Độ dài tối đa hậu tố" prop="payment_code_suffix_to">
              <el-input-number
                v-model="formData.payment_code_suffix_to"
                :min="1"
                :max="30"
                class="full-width-number"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Kiểu ký tự hậu tố" prop="payment_code_suffix_character_type">
          <el-select v-model="formData.payment_code_suffix_character_type" placeholder="Chọn kiểu ký tự..." class="full-width">
            <el-option
              v-for="item in listType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Số lượng giao dịch tối đa" prop="transaction_amount">
          <div class="flex gap-2 align-center">
            <el-input
              v-model="formData.transaction_amount"
              :disabled="formData.transaction_amount === 'Unlimited'"
              placeholder="Nhập số lượng giao dịch tối đa..."
              style="flex: 1;"
            />
            <el-checkbox
              v-model="checkTransactionAmount"
              class="modern-checkbox ml-2"
              @change="handleChangeTransactionAmount"
            >
              Không giới hạn
            </el-checkbox>
          </div>
        </el-form-item>

        <div
          v-if="examplePaymentCode"
          v-html="examplePaymentCode"
          class="example-badge-box mb-3"
        />
      </el-form>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "ConfigBrandDialogVersion2",
  components: { DialogBase },
  props: {
    isOpenConfigBrandDialog: {
      type: Boolean,
      default: () => false
    },
    xid: {
      type: String,
      default: () => "0"
    }
  },

  data() {
    return {
      formData: {
        payment_code: "off",
        payment_code_prefix: "OGV",
        payment_code_suffix_from: 10,
        payment_code_suffix_to: 10,
        payment_code_suffix_character_type: "NumberAndLetter",
        transaction_amount: "Unlimited",
        xid: ""
      },
      checkTransactionAmount: false,
      rules: {
        payment_code_prefix: [
          { required: true, message: "Tiền tố mã thanh toán không được để trống!", trigger: "change" },
          { max: 5, message: "Tối đa 5 ký tự", trigger: "change" },
          {
            pattern: /^[A-Z]*$/,
            message: "Chỉ cho phép chữ cái in hoa (A-Z)",
            trigger: "change"
          }
        ],
        payment_code_suffix_character_type: [
          {
            required: true,
            message: "Kiểu ký tự hậu tố mã thanh toán không được để trống!",
            trigger: "change"
          }
        ]
      },
      listType: [
        { value: "NumberAndLetter", label: "Cho phép chữ cái và số" },
        { value: "NumberOnly", label: "Chỉ cho phép chữ số" }
      ],
      loading: {
        submit: false
      }
    };
  },
  
  computed: {
    examplePaymentCode() {
      if (this.formData.payment_code !== "on") {
        return null;
      }

      const prefix = this.formData.payment_code_prefix || "ABC";
      const suffixLength = Math.max(
        this.formData.payment_code_suffix_from || 1,
        this.formData.payment_code_suffix_to || 1
      );

      const charset = this.formData.payment_code_suffix_character_type === "NumberOnly"
        ? "0123456789"
        : "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

      let suffix = "";
      for (let i = 0; i < suffixLength; i++) {
        suffix += charset.charAt(Math.floor(Math.random() * charset.length));
      }

      return `<div class="ex-wrapper">
        <span class="ex-label">Ví dụ cấu trúc mã:</span>
        <span class="code-result">
          <span class="prefix-color">${prefix}</span><span class="suffix-color">${suffix}</span>
        </span>
      </div>`;
    }
  },

  methods: {
    handleChangeTransactionAmount() {
      if (this.checkTransactionAmount === true) {
        this.formData.transaction_amount = "Unlimited";
      } else {
        this.formData.transaction_amount = "1000";
      }
    },

    handleClose() {
      this.checkTransactionAmount = false;
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },
    
    handleOpen() {
      sePayConnectionService.getDetailCompanyV2(this.$props.xid).then((res) => {
        this.formData = res.data.data;
        this.formData.xid = this.$props.xid;
        if (this.formData.transaction_amount === "Unlimited") {
          this.checkTransactionAmount = true;
        }
      });
    },
    
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          try {
            const resp = await sePayConnectionService.updateCompanyConfigV2(this.formData);
            if (resp.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Cập nhật cấu hình thành công!");
            } else {
              NotifyMessage.leftCornerNotificationError("Cập nhật cấu hình thất bại!");
            }
            this.handleClose();
          } catch (err) {
            console.error(err);
            this.handleClose();
          } finally {
            this.loading.submit = false;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modern-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  /deep/ .el-input__inner {
    border-radius: 8px;
    height: 40px;
  }
}

.full-width {
  width: 100% !important;
  
  /deep/ .el-input__inner {
    width: 100% !important;
  }
}

.full-width-number {
  width: 100% !important;
  
  /deep/ .el-input-number__decrease, /deep/ .el-input-number__increase {
    height: 38px;
    line-height: 38px;
  }
}

.modern-checkbox {
  font-weight: 600;
  color: #475569;
}

.example-badge-box {
  background-color: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
  
  /deep/ .ex-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;

    .ex-label {
      font-weight: 700;
      color: #64748b;
    }
    
    .code-result {
      font-family: Consolas, Monaco, monospace;
      font-weight: 700;
      font-size: 14px;
      
      .prefix-color {
        color: #2563eb;
      }
      .suffix-color {
        color: #ea580c;
      }
    }
  }
}

.mb-3 { margin-bottom: 12px; }
.mb-4 { margin-bottom: 16px; }
.flex { display: flex; }
.align-center { align-items: center; }
.gap-2 { gap: 8px; }
.ml-2 { margin-left: 8px; }
</style>